var _path, _path2, _path3, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 961.36 197.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.27,52.7V13.83H14.55V0H51.37V13.83H41.65V52.7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.13,52.7V0H71V17.94h9.4V0H97.27V52.7H80.36V33.18H71V52.7Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M102.8,52.7V0h31.05V13.83H119.63v5.84h14V32.79h-14v6.08H134.4V52.7Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 60.75,
    width: 961.36,
    height: 136.56
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.55,187.93V70.51H58.66a40.38,40.38,0,0,1,18.62,4A27.71,27.71,0,0,1,89.53,87.2q4.35,8.64,4.36,22.73,0,13.75-5,22.9a32.84,32.84,0,0,1-13,13.58,35.14,35.14,0,0,1-17.28,4.45H46.42v37.07Zm31.87-64.41H53.3A6.15,6.15,0,0,0,58,121.75a10.32,10.32,0,0,0,2.43-4.61,22.56,22.56,0,0,0,.76-5.87,20.55,20.55,0,0,0-.76-5.79A9.72,9.72,0,0,0,58,101.21a6.33,6.33,0,0,0-4.69-1.68H46.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.1,70.51H133V187.93H101.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.23,70.51h32V187.93H146.89Zm45.45,0a39.33,39.33,0,0,1,18,4,29.83,29.83,0,0,1,12.58,12q4.62,8,4.62,20.21,0,12.75-5.2,21.14a33.24,33.24,0,0,1-13.34,12.49,37.6,37.6,0,0,1-17.19,4.11H163.66v-74Zm-14.09,57,30.87.84,19.12,54.68v4.87H195.2Zm1.18-10.06h8.38a5.58,5.58,0,0,0,3.95-1.34,7.53,7.53,0,0,0,2-3.61,19,19,0,0,0,.59-4.78,13.35,13.35,0,0,0-.59-4,6.46,6.46,0,0,0-2-3,6.08,6.08,0,0,0-3.95-1.17h-8.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.92,187.93v-4.7l21-112.72,49.82.17,21,112.55v4.7H288.29l-2.52-21.64H266l-2.52,21.64ZM269,138.61h13.75l-4.36-37.74h-5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.75,70.51V100h-19v87.9H335.92V100H316.13V70.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.53,70.51v29H427.67v17.61a89.87,89.87,0,0,1,9.15-2.51,66.68,66.68,0,0,1,9.05-1.35,41.34,41.34,0,0,1,8.31.17v28.18l-1.85,1a32.74,32.74,0,0,0-7.13-1.34,41.5,41.5,0,0,0-8.3.16,51.18,51.18,0,0,0-9.23,2v15.43h29.86v29H395.8V70.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.85,187.93V70.51H552a40.35,40.35,0,0,1,18.62,4A27.71,27.71,0,0,1,582.83,87.2q4.35,8.64,4.36,22.73,0,13.75-5,22.9a32.84,32.84,0,0,1-13,13.58A35.14,35.14,0,0,1,552,150.86H539.72v37.07Zm31.87-64.41h6.88a6.15,6.15,0,0,0,4.69-1.77,10.32,10.32,0,0,0,2.43-4.61,22.56,22.56,0,0,0,.76-5.87,20.55,20.55,0,0,0-.76-5.79,9.72,9.72,0,0,0-2.43-4.27,6.33,6.33,0,0,0-4.69-1.68h-6.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643,70.51h32.21V187.93H643V143.48H626.77v44.45H594.4V70.51h32.37V115H643Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.14,129.22q0-21.3,6.88-34.72t18.11-19.71a49.7,49.7,0,0,1,48.4,0q11.15,6.28,18,19.71t6.87,34.72q0,21.3-6.87,34.72t-18,19.71a49.7,49.7,0,0,1-48.4,0Q698.9,177.37,692,163.94T685.14,129.22Zm33.05,0a55,55,0,0,0,2.18,16.69q2.18,6.79,5.87,10.31a11.46,11.46,0,0,0,8,3.53,11.64,11.64,0,0,0,8.22-3.53q3.69-3.51,6-10.31a53.25,53.25,0,0,0,2.27-16.69q0-10.23-2.27-16.94t-6-10.15a11.79,11.79,0,0,0-8.22-3.44,11.6,11.6,0,0,0-8,3.44q-3.69,3.44-5.87,10.23A55.67,55.67,0,0,0,718.19,129.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M841.81,70.51h31V187.93h-30.7L824.19,136.1h-1.51l1.51,51.83h-31V70.51H824L842,124.19h1.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M948.48,70.51v29H918.63v17.61a89.69,89.69,0,0,1,9.14-2.51,66.59,66.59,0,0,1,9.06-1.35,41.25,41.25,0,0,1,8.3.17v28.18l-1.85,1a32.74,32.74,0,0,0-7.13-1.34,41.52,41.52,0,0,0-8.3.16,50.9,50.9,0,0,0-9.22,2v15.43h29.85v29H886.76V70.51Z",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.45ececdb4d970ce2cbea9eaae3384913.svg";
export { ForwardRef as ReactComponent };